import FullWysiwyg from "@/components/ssp/missions/mission/site/partials/FullWysiwyg.vue";

export default function useGlobalComponents(app) {
  app.component("FullWysiwyg", FullWysiwyg);
}
